import type { Request } from '../../../index'

export type NewKitParams = {
  title: string
  fixed_price_enabled?: boolean // опционально, устанавливает наличие фиксированной цены
  fixed_price?: string // опционально, устанавливает фиксированную цену
}

export type NewComplexResult = {
  id: number
  title: string
  fixed_price_enabled: boolean
  fixed_price?: string
  deletable: boolean
  photo_url: ''
  visible: boolean
}

type UrlParams = {
  orgId: number | string
}

export const POST_NEW_COMPLEX: Request<NewKitParams, NewComplexResult, UrlParams> = [
  'food/schools/{orgId}/complexes',
  'post',
  ['data', 'complexes'],
]
